import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { donationActions } from "../redux/donation-slice";
import useHttps from "./useHttps";
import useReporting from "./useReporting";

const useDonations = () => {
   const { sendRequest } = useHttps();
   const dispatch = useDispatch();
   const { apiErrorReportingService } = useReporting();

   const getDonationsSuccess = (data) => {
      dispatch(donationActions.setDonationsResponse(data?.data));
   };

   const getDonationsTypeSuccess = (data) => {
      dispatch(donationActions.setDonationTypes(data?.data?.content));
   };

   const getDonationLoaderFunc = (value) => {
      dispatch(donationActions.setGetLoading(value));
   };

   const getDonationsError = (error) => {
      dispatch(donationActions.setDonationsResponse({}));
      apiErrorReportingService(error);
   };

   const searchDonations = (value) => {
      const searchValue = value ? `userDetails.fullName:${value.trim()}*` : "";

      getDonations({ pageSize: 10, pageNo: 0, search: searchValue });
   };

   const getDonationTypes = useCallback(() => {
      const config = {
         method: "get",
         url: `donation/get-donation-types`,
      };

      sendRequest(
         config,
         getDonationsTypeSuccess,
         null,
         apiErrorReportingService
      );
   }, [sendRequest]);
   const getDonations = useCallback(
      ({ pageSize = 10, pageNo = 0, sortBy = "id", search = "" }) => {
         const config = {
            method: "get",
            url: `donation/get-donation-history?pageSize=${pageSize}&pageNo=${pageNo}&sortBy=${sortBy}&search=${search}`,
         };

         sendRequest(
            config,
            getDonationsSuccess,
            getDonationLoaderFunc,
            getDonationsError
         );
      },
      [sendRequest]
   );

   return { getDonations, getDonationTypes, searchDonations };
};

export default useDonations;
